<template>    
  <v-row justify="center" no-gutters>
    <v-col cols="12">
      <v-card>
        <v-container fluid>
          <o-big-title justify="start">
            <slot name="title">Título sección</slot>
          </o-big-title> 
          <slot name="content"/>
          <slot name="button-content">
            <v-row v-if="showButton" no-gutters justify="center" align="center" class="mt-8">
              <v-btn
                @click="$emit('save')"
                color="primary"
                :disabled="disabled"
                :loading="loading"
              >
                <slot name="button-text">
                  {{this.$t('guardarCambios')}}
                </slot>
              </v-btn>
            </v-row>
          </slot>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    showButton: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>